module.exports = __webpack_public_path__ + "svg/illustration-tenant-eviction.9662a67.svg";